import { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client/react'
import { SupportMessengerDocument } from '../operations-types'
import { bootSupportChat } from '../lib/supportChat'

export function useSupportChat(enabled: boolean): void {
  const { data } = useQuery(SupportMessengerDocument, {
    skip: !enabled,
    fetchPolicy: 'network-only',
  })
  const session = data?.supportMessenger?.session
  const [bootedToken, setBootedToken] = useState<string | null>(null)

  useEffect(() => {
    if (!session || session.token === bootedToken) return
    bootSupportChat(session)
    setBootedToken(session.token)
  }, [session, bootedToken])
}
